// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"635e0e05","498":"844f760f","703":"37cea128","787":"e2c65842"}[chunkId] + ".chunk.js";
};